import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromSettingSelectors from '../../store/selectors/setting.selectors';

@Injectable({
  providedIn: 'root'
})
export class ReferralCodeGuard {
  private store = inject(Store);
  private router = inject(Router);

  hasValidReferralCode = false;
  constructor() {
    this.store.pipe(select(fromSettingSelectors.selectHasValidReferralCode)).subscribe((hasValidReferralCode) => {
      this.hasValidReferralCode = hasValidReferralCode;
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasValidReferralCode ? true : this.router.createUrlTree(['onboarding', 'referral']);
  }
}
